export const ru = (__LOCALE_RU__ ? ({
  permission_tag_general_info: {
    title: 'Общая информация',
    data: {
      name: 'Название',
      created: 'Создано',
    },
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  permission_tag_general_info: {
    title: 'General information',
    data: {
      name: 'Title',
      created: 'Created',
    },
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  permission_tag_general_info: {
    title: 'Información general',
    data: {
      name: 'Nombre',
      created: 'Creado',
    },
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  permission_tag_general_info: {
    title: 'Informações gerais',
    data: {
      name: 'Nome',
      created: 'Criado',
    },
  },
}) : {}) as Record<string, unknown>;
